import { api } from "api/api";
import { AxiosError } from "axios";
import Usuario from "model/administracao/cadastro/Usuario";
import Setor from "model/administracao/cadastro/Setor";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";
import { DataTableFilterMeta } from "primereact/datatable";
import PlanoAuditoria from "model/auditoria5s/planoDeAuditoria/PlanoAuditoria";
import SetorPlanoAuditoria from "model/auditoria5s/planoDeAuditoria/SetorPlanoAuditoria";
import { generateKey } from "utils/generateKey";
import UnidadeOrganizacional from "model/indicadores/UnidadeOrganizacional";

class SetorService implements BaseServiceCadastros<Setor> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/setor/pesquisar`;
            url += getFilters(filters)
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<Setor>((resolve, reject): void => {
            api
                .get(`/setor/consultar/${id}`)
                .then(response => {
                    const setor: Setor = response.data;

                    setor.planos.forEach((setorPlanoAuditoria: SetorPlanoAuditoria) => {
                        setorPlanoAuditoria.key = generateKey();
                    });

                    resolve(setor)
                })
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(setor: Setor) {
        return new Promise<Setor>((resolve, reject): void => {
            api
                .post(`/setor/incluir`, JSON.stringify(setor))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(setor: Setor) {
        return new Promise<Setor>((resolve, reject): void => {
            api
                .put(`/setor/editar`, JSON.stringify(setor))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/setor/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    usuarios(idConta?: number) {
        return new Promise<Array<Usuario>>((resolve, reject): void => {
            let url = `/setor/usuarios`;
            if (idConta) {
                url += `?idConta=${idConta}`;
            }
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    planos(idConta?: number) {
        return new Promise<Array<PlanoAuditoria>>((resolve, reject): void => {
            let url = `/setor/planos`;
            if (idConta) {
                url += `?idConta=${idConta}`;
            }
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    unidadesOrgan(idConta?: number) {
        return new Promise<Array<UnidadeOrganizacional>>((resolve, reject): void => {
            let url = `/setor/unidadesOrganizacionais`;
            if (idConta) {
                url += `?idConta=${idConta}`;
            }
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default SetorService;
